<div class="mv-tiles-wrapper">
  <ng-container *ngFor="let item of graphics; let i = index">
    <div
      class="set-banner"
      [ngStyle]="{ top: 100 + i * 50 + 'px' }"
      (click)="changeContent(i)"
    >
      <img src="{{ item.icon_url }}" alt="" />
      <p *ngIf="current_language == 'de'">{{ item.name_de }}</p>
      <p *ngIf="current_language == 'en'">{{ item.name_en }}</p>
    </div>
  </ng-container>
  <!-- dashboard -->
  <div *ngIf="current_index == -1">
    <h1>{{ i18n.mv.heading }}</h1>
    <div
      innerHtml="{{ free ? i18n.mv.licence_free : i18n.mv.licence_mv }}"
      style="text-align: left;"
    ></div>
  </div>
  <!-- show tileset -->
  <div *ngIf="current_index >= 0">
    <h1 *ngIf="current_language == 'de'">
      {{ graphics[current_index].name_de }}
    </h1>
    <h1 *ngIf="current_language == 'en'">
      {{ graphics[current_index].name_en }}
    </h1>
    <img
      class="sample-image"
      src="{{ graphics[current_index].image_url }}"
      alt=""
    />
    <hr />
    <a href="{{ graphics[current_index].download_url }}">
      <button>
        {{ i18n.mv.download }}
      </button>
    </a>
    <hr />
    <div class="image-container">
      <ng-container
        *ngFor="let image of graphics[current_index].images; let i = index"
      >
        <img src="{{ image }}" alt="" />
      </ng-container>
    </div>
  </div>
</div>
